/** RFC 5322's characters for an unquoted local part, beside letters and digits. */
const LOCAL_SPECIALS = new Set("!#$%&'*+/=?^_`{|}~-.");
const isLetterOrDigit = (ch) => /[\p{L}\p{N}]/u.test(ch);
const isLetter = (ch) => /\p{L}/u.test(ch);
/**
 * Whether text is an e-mail address the CRM stores for a candidate (TS-2014). Wider than
 * `z.email()`, which refused 32 RecruitCRM addresses that are well formed (Victor, DATA-1306 #33):
 *
 * - **local part**: letters and digits of any script (RFC 6531: `josé`, `peña`) and RFC 5322's
 *   unquoted specials (`! # $ % & ' * + / = ? ^ _ \` { | } ~ - .`), up to 64 characters, no leading,
 *   trailing or doubled dot;
 * - **domain**: two labels or more, each letters, digits and inner hyphens (up to 63), the last
 *   one letters only, two or more. So `gmail.com1` and `gmail.c` are still refused.
 *
 * No regular expression spans the input (SonarQube S5852): the parts are split and checked one
 * character at a time. Text is taken as given (callers trim and lower-case).
 */
export function isEmailAddress(text) {
    if (text.length > 320)
        return false;
    const at = text.indexOf('@');
    if (at <= 0 || at !== text.lastIndexOf('@'))
        return false;
    const local = text.slice(0, at);
    const domain = text.slice(at + 1);
    if (local.length > 64 || local.startsWith('.') || local.endsWith('.') || local.includes('..'))
        return false;
    for (const ch of local)
        if (!isLetterOrDigit(ch) && !LOCAL_SPECIALS.has(ch))
            return false;
    if (domain.length > 253)
        return false;
    const labels = domain.split('.');
    if (labels.length < 2)
        return false;
    for (const label of labels) {
        if (label.length === 0 || label.length > 63)
            return false;
        if (label.startsWith('-') || label.endsWith('-'))
            return false;
        for (const ch of label)
            if (!isLetterOrDigit(ch) && ch !== '-')
                return false;
    }
    const tld = [...labels.at(-1)];
    return tld.length >= 2 && tld.every(isLetter);
}
//# sourceMappingURL=email-address.js.map